import { db, EntryAttributeDB, ItemTypeDB, UserDB, cats_default } from "@/ts/DexieDB";
import Categories from "./Categories";
import DataBaseTests from "./DataBaseTests";
import CategoryData, { CatDB } from "./DataTypes/CategoryData";

//@ts-ignore
import Entry, { EntryDB } from "./DataTypes/Entry";
import Helpers from "./Helpers";
import { SupabaseClient, createClient } from '@supabase/supabase-js'
import { ObjectIn } from "@/components/InputTextSmart.vue";

// Define the types for your database schema (optional)
interface Database {
    public: {
      Tables: {
        users: {
          Row: {
            id: string;
            email: string;
            // add other fields here
          };
          Insert: {
            email: string;
            // add other fields here
          };
          Update: {
            email?: string;
            // add other fields here
          };
        };
        // add other tables here
      };
    };
  }

export default class DataSupaBase
{
    
    supabase!:SupabaseClient<Database>;
    user:any;

    constructor(){this.Init();return this;}

    async Init()
    {
        this.supabase = createClient(
            //under projects->settings-> API-> project URL
            'https://xhiarkdzworpzlysfhkt.supabase.co', 
            //under projects->settings-> API-> Project API keys
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhoaWFya2R6d29ycHpseXNmaGt0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTI3MzYzNjYsImV4cCI6MjAwODMxMjM2Nn0.D1VkpB4tmbAir9UAL0GSy0tjEd0Zhkl-AtutcjyEhOo');
            console.log("finished getting superbase client", this.supabase);
        return this.supabase;
    }
    async GetUser()
    {
        console.log("getting user");
        
        // this.handleRedirect();

        // let response2 = await this.supabase.auth.getSession(); // on android, it doesn't always refresh the session correctly- when trying to call GetCats next- it 
        //returns that the JWT has expired, returns a 401 error

        //NOTE: 6/2/2024- supabase has started throwing CORS errors if you try to use this in firefox, but doesn't in chrome. 
        //so in firefox, we get an error after logging in, but we don't in chrome....
        console.warn("supabase stopped allowing you to login in firefox, throws a CORS ERROR, but doesn't in chrome. Found it's because 'privacy badger/ ad block started blocking supabase randomly!!!");
        let response2 = await this.supabase.auth.refreshSession();
        console.log("response2 / session: ", response2, JSON.stringify(response2));
		if(response2.data.session)
		{
			let jwt = response2.data.session.access_token;
			this.user = response2.data.session.user;

			console.log("jwt: ", jwt, "user: ", this.user);
		}
        return this.user;
    }

    //NEW after adding capacitor- for some reason GetUser isn't working, so trying to add a new way to do it through the url- not sure why it stopped working after adding capacitor
    // async handleRedirect() 
    // {
    //     const url = new URL(window.location.href); // Get current URL
    //     const accessToken = url.hash.match(/access_token=([^&]+)/)?.[1]; // Extract token
    //     const refreshToken = url.hash.match(/refresh_token=([^&]+)/)?.[1]; // Extract refresh token (if any)
    //     console.log("handling redirect, accessToken: ", accessToken, "refreshToken: ", refreshToken, "this client: ",this.supabase);
    
        
    //     if (accessToken) {
    //         alert("going to send supabase access tokens");
    //         // Set the session in Supabase client
    //         const { data, error } = await this.supabase.auth.setSession({
    //             access_token: accessToken,
    //             refresh_token: refreshToken as string
    //         });
    //         if (error) {
    //             // Handle error (e.g., invalid token)
    //             console.error('Error setting session:', error);
    //         } else {
    //             // Session successfully created
    //             console.log('Session:', data.session);
    //             // Redirect to the appropriate page
    //             window.location.hash = ''; // Remove token from URL
    //             window.location.pathname = '/dashboard'; // Or your desired path
    //         }

    //         alert("done sending supabase access tokens");
    //     }
    // }

    //get all categories for the user
    async GetCats()
    {
        let cats = new Array<CategoryData>();
        console.log("Getting cats2");
        let { data: rows, error } = await this.supabase
        .from('categories')
        .select('*')
        .order('updated_at', { ascending: false });
        console.log("Cats are:", rows);
        console.warn("DataSupabase: Data: Fetched Cats from database, error: ", error);

        (rows as Array<any>).forEach((row)=>{
            //format in database: created_at, updated_at, name, type, color_bg, color_txt, icon
            cats.push(new CategoryData({id:row.id, name:row.name, type:row.type, color_bg:row.color_bg, color_txt:row.color_txt, icon:row.icon, date_updated:new Date(row.updated_at) }));
        })
        

        console.log("Cats in cat data format are:", cats);

        //if cats are empty, should populate with default data

        return cats;
    }
    //to add multiple cats at once
    async AddCats(cats:Array<CategoryData>)
    {
        //convert to the format that supabase requires:
        let cats_supa = new Array<any>();
        cats.forEach((cat)=>{
            cats_supa.push({name:cat.name, type:cat.type, color_bg:cat.color_bg, color_txt:cat.color_txt, icon:cat.icon, });
        });
        

        return this.InternalAddSupaCatOrCats(cats_supa);
    }
    async AddOrEditCat(cat:CategoryData)
    {
        console.log("DataSupa AddOrEditCat: going to add or edit cat: ", cat);
        let cat_supa = {name:cat.name, type:cat.type, color_bg:cat.color_bg, color_txt:cat.color_txt, icon:cat.icon};

        if(!cat.id) //add new cat
            return  ((await this.InternalAddSupaCatOrCats([cat_supa])) as Array<any>)[0];
        else    //edit existing cat
        {
            (cat_supa as any).id=cat.id;
            return await this.InternalEditSupaCat(cat_supa);
        }

    }
    async InternalAddSupaCatOrCats(cat_or_cats:any)
    {
        const { data, error } = await this.supabase
        .from('categories')
        .insert(cat_or_cats) //needs to be in an array
        .select();
        console.log("inserted new cats, with results: ", data, error);
        console.warn("DataSupabase: Data: Add Cats to database");
        return data;
    }
    async InternalEditSupaCat(cat:any)
    {
        const { data, error } = await this.supabase
            .from('categories')
            .update(cat)
            .eq('id', cat.id)

        console.log("edited existing cat, with results: ", data, error);
        console.warn("DataSupabase: Data: edited Cats in database");

        //just return the supabase version of the cat to update the original
        return cat;
    }

    async CategoryDelete(cat_id:string)
    {
        console.log("DataSupaBase: CategoryDelete: ", cat_id);
        const { data, error } = await this.supabase
                .from('categories')
                .delete()
                .eq('id', cat_id);

        if(error)
            console.log("DataSupaBase: CategoryDelete: error encountered: ", error);
        else
            console.log("DataSupaBase: CategoryDelete: NO error encountered: ", data);

        return error;
    }

    //for auto completing entries names
    /* async GetPrevEntriesForCat(id_cat:string)
    {
        console.warn("GetRecentEntries, need to fill in");
        return new Array();
    } */
    async GetPrevAttributesForCat(id_cat:string)
    {
        console.warn("GetPrevAttributesForCat, need to fill in");
        return new Array();
    }

    async AttributesGetForEntry(entry_id:string)
    {
        console.warn("SKIPPING getting attributes");
        //need to get them all in an array with one request, like: https://stackoverflow.com/questions/75717077/how-do-i-fetch-multiple-specific-rows-in-supabase-js
        /* 
            const { data, error } = await supabase
            .from('contacts')
            .select()
            .in('id', associatedContactsArray)
            
        */
        return [];


    }
    
    /**
     * 
     * @param attributes an array of attributes
     * @param crud_operation which crud operation to perform (create, read, update, delete)
     */
    async AttributeCreateUpdateOrDelete(attributes:Array<any>, crud_operation:string)
    {
        let attributes_supra = attributes.map((attr:any) => {
            
            let supa_attr = {name:attr.name, value:attr.value, rating:attr.rating, id_cat:attr.id_cat, id_entry:attr.id_entry};
            if(attr.id!=-1) //if editing an existing one/ not new one
                (supa_attr as any).id = attr.id
            return supa_attr;
            
        });
        console.log("DataSupabase: AttributeCreateUpdateOrDelete: attributes_supra: ", attributes_supra, crud_operation);

        //for now, return to stop from actually doing something on the server while fixing editing bug
        // console.warn("DataSupabase: AttributeCreateUpdateOrDelete: attributes_supra: ", attributes_supra, crud_operation);
        // return

        //have to convert it into just the format supabase expects

        if(crud_operation=="create"||crud_operation=="update")
        {
            console.log("DataSupabase:create or update, passing over: ", attributes_supra);
            //bulk way of doing insert or update is to use upsert- no bulk way of updating otherwise
            const { data, error } = await this.supabase
            .from('attributes')
            .upsert(attributes_supra)
            .select();
            console.warn("DataSupabase: Data: attributes finished creating or updating, with response: ", data);
            
            return data;
        }
        else if(crud_operation=="delete")
        {
            attributes_supra.forEach(async (attribute:any) => {                
                const { error } = await this.supabase
            .from('attributes')
            .delete()
            .eq('id', attribute.id);
            console.warn("DataSupabase: Data: attributes finished deleted", attribute, "error: ", error); 
            });
            
        }
    }


   /*  async AddOrEditEntry(entry:any)
    {
        console.log("AddEntry: ", entry);

        let entry_supra = {id_cat:entry.id_cat, name:entry.item_type, tracking:entry.tracking, has_duration:entry.has_duration, 
            
            //NOTE: date_updated locally is the date the entry starts, not the actual updated date
            date_started:entry.date_updated,
            date_finished:entry.date_finished, };

        //if a user_id and id are included- it's an update
        if(entry.id)
        {
            
            
            this.EntryUpdate(entry);
        }
        else
        {
            this.EntryAdd(entry)
        }
    } */
    async EntryAdd(entries:Array<any>)
    {
        let entries_supra = new Array<any>();

        for (let i = 0; i < entries.length; i++) 
        {
            const entry = entries[i];
            
            let entry_supra = {id_cat:entry.id_cat, name:entry.item_type, tracking:entry.tracking, has_duration:entry.has_duration, 
        
            //NOTE: date_updated locally is the date the entry starts, not the actual updated date
            date_started:entry.date_updated,
            date_finished:entry.date_finished, };
    
            if(!entry_supra.date_finished)
            {
                console.warn("Changing prop from undefined to null - supabase doesn't update anything that is undefined- it will ignore it");
                entry_supra.date_finished=null;
            }
    
            console.log("AddOrEditEntry: Adding new entry!: entry_supra: ", entry_supra);

            entries_supra.push(entry_supra);
        }

        

        // const { data, error } = await this.supabase
        let result = await this.supabase
        .from('entries')
        .insert(entries_supra) //needs to be in an array
        .select();
        console.log("inserted new entry(s), with results: ", result.data, result.error);
        console.warn("DataSupabase: Data: Added entry(s) in database");
        //fix issues with JS not handling supabase correctly- supabase stores undefined as null, and JS defines nulls as undefined
        if(!result.error)
        {
            for (let i = 0; i < result.data.length; i++) 
            {
                const entry_back = result.data[i];
                result.data[i]= this.ConvertSupaEntryToLocalEntry(entry_back, undefined);    

                 //also update the cats updatedat while we're at it, since I can't get the TriggerWorking in postgres yet
                //probably don't need to wait for it, since it takes extra time
                /*await */
                this.UpdateCatUpdatedAt(entries[i].id_cat);
            }
        }

        return result;
    }
    

    async EntryUpdate(entry:any)
    {
        let entry_supra = this.ConvertLocalEntryToSupaEntry(entry);

        console.log("AddOrEditEntry: Editing existing entry!: entry_supra: ", entry_supra, "and id(not in supa object): ",entry.id);
        // const { data, error } = await this.supabase
        let result = await this.supabase
        .from('entries')
        .update(entry_supra)
        .eq('id', entry.id).select();
        console.log("Edited entry, with results: ", result.data, result.error);
        console.warn("DataSupabase: Data: Editing entry in database");

        if(!result.error)
        {
            
            const entry_back = result.data[0];
            result.data[0]= this.ConvertSupaEntryToLocalEntry(entry_back, undefined);    

            this.UpdateCatUpdatedAt(entry.id_cat);
            
        }

        return result;


        // return result;
    }

    async UpdateCatUpdatedAt(cat_id:string)
    {
        let result = await this.supabase
            .from('categories')
            .update({updated_at:this.ConvertDateToSupaBaseDateForSearching(new Date())})
            .eq('id', cat_id);

        console.log("UpdateCatUpdatedAt, with results: ", result.data, result.error);
    }



    async EntryDelete(entry_id:string)
    {
        console.log("DataSupaBase: DeleteEntry: ", entry_id);
        const { data, error } = await this.supabase
                .from('entries')
                .delete()
                .eq('id', entry_id);

        if(error)
            console.log("DataSupaBase: DeleteEntry: error encountered: ", error);

        return error;
    }

    // async EditEntry(entry:EntryDB)
    // {
    // }

    //doesn't seem to work if you to to get a supabase entry between a certain date with the date object-
    // converting to iso string: date_end.toISOString(); allowed it to try- but didn't return anything. they used it here, but didn't work for me: https://github.com/orgs/supabase/discussions/4812
    // but reddit says using YYYY-MM-DD format actually works: https://www.reddit.com/r/Supabase/comments/11mp66c/help_converting_a_query_to_filter_by_date_into/

    ConvertDateToSupaBaseDateForSearching(date:Date)
    {
        /* return date.getFullYear()+"-"+
        String(date.getMonth()).padStart(2, '0')+"-"+
        String(date.getDate()).padStart(2, '0'); */
        //supabase needs iso string format: https://github.com/orgs/supabase/discussions/2839
        return date.toISOString();
    }

    /**
     * For gettign the previous 'x' number of entries for a category, for auto complete - 
     * @param id_cat 
     */
    async GetEntriesPrevForCategory(id_cat:string, limit:number=48)
    {
        console.log("supabase version: ", this.supabase);
        // let { data: rows, error } = await this.supabase.from('entries').select('id, name, date_started').distinct() //distinct should work- but they seem to have removed it frpom the github repo/ no mention of it, but the AI still references it
        
        /* let { data: rows, error } = await this.supabase.from('entries').select('id, name, date_started')
        .eq('id_cat', id_cat)
        .order('date_started', { ascending: false })
        .limit(limit); */

        let { data: rows, error } = await this.supabase.rpc('get_distinct_entries', { p_id_cat: id_cat, p_max_limit: limit });
        // console.log("trying out rpc function, rows: ", rows, "error: ", error);

        //but need to change the names that came back- the rpc function changed them, so have to fix them
        for (let i = 0; i < rows.length; i++) 
        {
            rows[i].id=rows[i].entry_id
            rows[i].name=rows[i].entry_name
            rows[i].date_started=rows[i].entry_date_started
        }
        // console.log("trying out rpc function2, rows: ", rows, "error: ", error);

        /* 
        .from('players')

  .select('*')

  .order('team_id, player_id')

  .group('team_id')

  .limit(1); */

        //get rid of any duplicates
        let prev_entries = new Array();
        // check if an entry is already in prev entries, and only add if it is not
        for (let i = 0; i < rows.length; i++) 
        {
            const new_row = rows[i];
            let found=false;
            for (let j = 0; j < prev_entries.length; j++) 
            {
                const old_row = prev_entries[j];
                if(old_row.name==new_row.name)
                {
                    found=true;
                    break;
                }
                
            }
            if(!found)
                prev_entries.push(new ObjectIn().Init(new_row.id, new_row.name, new Date(new_row.date_started)));
            
        }

        console.log("GetEntriesPrevForCategory are: rows", rows, "for cat id: ", id_cat);
        //change to ObjectIn for input_smart
        // prev_entries = (rows as Array<any>).map((row)=>{


        //     return new ObjectIn().Init(row.id, row.name, new Date(row.date_started))
        // });

        // let entries = new Array<Entry>();
        console.warn("GetEntriesPrevForCategory are:", prev_entries, "for cat id: ", id_cat);
        return prev_entries;
    }

	async GetEntriesBySearch(search_term:string)
	{

		console.log("GetEntriesBySearch: gettign entries using search, search_term: ", search_term);
		// console.log("NEED TO ADD CONNECTION TO SUPABASE TO SEARCH BY ENTRY NAME");
		let { data: rows, error } = await this.supabase.from('entries').select().textSearch('name', `'${search_term}'`).order('date_started', { ascending: false });

		let entries = new Array<Entry>();
        console.log("Entries are:", rows);


        //have to use for loop- foreach will skip past if promise inside/ won't finish, just skips to the end and doesn't care about await
        for (let i = 0; i < (rows as Array<any>).length; i++) 
			{
				const row = (rows as Array<any>)[i];
				let attributes = await this.AttributesGetForEntry(row.id);
				entries.push(this.ConvertSupaEntryToLocalEntry(row, attributes));
				
			}
			console.log("Entries for search term : ", entries);

		return entries;
	}
    async GetEntries(date_start:Date, date_end:Date)
    {

        console.log("DataSupaBase: Get entries called1", date_start, date_end );
        (date_start as any)=this.ConvertDateToSupaBaseDateForSearching(date_start);
        (date_end as any)=this.ConvertDateToSupaBaseDateForSearching(date_end);

        
        console.log("DataSupaBase: Get entries called2", date_start, date_end );

        let { data: rows, error } = await this.supabase.from('entries').select('*')
        .gt('date_started', date_start)
        .lt('date_started', date_end)
        .order('date_started', { ascending: false });
        console.log("DataSupaBase: next line");

        let entries = new Array<Entry>();
        console.log("Entries are:", rows);

        // (rows as Array<any>).forEach(async (row)=>{
        //have to use for loop- foreach will skip past if promise inside/ won't finish, just skips to the end and doesn't care about await
        for (let i = 0; i < (rows as Array<any>).length; i++) 
        {
            const row = (rows as Array<any>)[i];
            let attributes = await this.AttributesGetForEntry(row.id);

            //format in database: created_at, updated_at, name, type, color_bg, color_txt, icon
            /* entries.push(new Entry({id:row.id, item_type:row.name,

                        //NOTE: date_updated locally is the date the entry starts, not the actual updated date
                        date_updated:new Date(row.date_started),
                        date_finished:row.date_finished?new Date(row.date_finished):undefined,

                        tracking:row.tracking, has_duration:row.has_duration,
                        id_cat:row.id_cat, id_user:row.id_user,
                        attributes:attributes
                        })); */
            entries.push(this.ConvertSupaEntryToLocalEntry(row, attributes));

            //should also add attributes onto the entries
            
        }
        console.log("Entries for date range are: ", entries, date_start, date_end);

        console.warn("DataSupabase: Data: Got entries in database");

        

        return entries;

        /* let cats = new Array<CategoryData>();
        console.log("Getting cats");
        let { data: rows, error } = await this.supabase
        .from('categories')
        .select('*');
        console.log("Cats are:", rows);

        (rows as Array<any>).forEach((row)=>{
            //format in database: created_at, updated_at, name, type, color_bg, color_txt, icon
            cats.push(new CategoryData({id:row.id, name:row.name, type:row.type, bg_color:row.color_bg, txt_color:row.color_txt, icon:row.icon, date_updated:new Date(row.updated_at) }));
        })

        console.log("Cats in cat data format are:", cats);

        //if cats are empty, should populate with default data

        return cats; */
    }
    ConvertSupaEntryToLocalEntry(row:any, attributes:any)
    {
        // result.data[0]= this.FixIssuesBeforeSendingBackToJS(result.data[0]);

        //format in database: created_at, updated_at, name, type, color_bg, color_txt, icon
        return new Entry({id:row.id, item_type:row.name,

            //NOTE: date_updated locally is the date the entry starts, not the actual updated date
            date_updated:new Date(row.date_started),
            date_finished:row.date_finished?new Date(row.date_finished):undefined,

            tracking:row.tracking, has_duration:row.has_duration,
            id_cat:row.id_cat, id_user:row.id_user,
            attributes:attributes
            });
    }

    /* 
    For converting dates from undefined to null for supabase
     */
    ConvertLocalEntryToSupaEntry(entry:any)
    {
        let date_start= entry.date_updated;
        if(!date_start)
            date_start=null;
        
        let date_end= entry.date_finished;
        if(!date_end)
            date_end=null;

        return {id_cat:entry.id_cat, name:entry.item_type, tracking:entry.tracking, has_duration:entry.has_duration, 
            
            //NOTE: date_updated locally is the date the entry starts, not the actual updated date

            date_started:date_start,
            date_finished:date_end};
    }

    /**
     * fix issues with returning objects to JS from supabase- 
     * certain things supabase needs to work, other things js needs to
     * changing nulls to undefined
     * @param obj an object to be fixed
     */
    FixIssuesBeforeSendingBackToJS(obj:any)
    {
        for (var prop in obj) 
        {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                if(obj[prop]==null)
                    obj[prop]=undefined;
            }
        }
        return obj;
    }

    //for getting realtime updates on the table- for entries only initially
    //NOTE: Bug in supabase- it sends EVERYONE every delete event. It deletes things first, then sends the delete event, and doesn't know the id of the user who owned the entry, so you just get a entry id that was deleted. Doesn't seem to be a way around this. Only thing is to have another table, that stores everything deleted, then emits an event when a deleted item is added to it.... seems dumb
    GetRealTimeEntryUpdates(callback:Function)
    {
        // Subscribe to real-time changes
        this.supabase
          .channel('entries')
          .on('postgres_changes', { event: '*', schema: 'public', table: 'entries' /* Filter by user_id*/ }, (payload) => {

            console.log("this user: ", this.user);
            console.log( "this user id: ",this.user.id);
            console.log('SupabaseChange received!', payload);

            if(payload.new)
            {
                //might also have to copy above: "AttributesGetForEntry" and add attributes for entries, when I start having attributes being used
                let entry_supra = this.ConvertSupaEntryToLocalEntry(payload.new, undefined);
                payload.new=entry_supra;
            }

            callback(payload);
            // Handle the update (e.g., refresh UI)
          })
          .subscribe();

          
    }


    
}




interface DeleteEntryInterface {
    cat_index: number,
    entry_index: number,
    entry_id: number,
}
interface UpdateEntryInterface {
    cat_index: number,
    entry_index: number,
    entry_id: number,
    entry:Entry
}